require('./vendor');
require('./theme/fonts/custom-font');
require('./theme/pcoded');
require('./forms')
window.helpers = require('./components/helpers').default

Array.remove = function (array, from, to) {
    var rest = array.slice((to || from) + 1 || array.length);
    array.length = from < 0 ? array.length + from : from;
    return array.push.apply(array, rest);
};

Number.prototype.formatMoney = function (c, d, t) {
    let n = this,
        cc = isNaN(c = Math.abs(c)) ? 2 : c,
        de = d === undefined ? "." : d,
        th = t === undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(cc)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + th : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + th) + (cc ? de + Math.abs(n - i).toFixed(cc).slice(2) : "");
};

$(document).ready(function () {

     // Initialize all selects to select2
     $("select.form-control, select.form-select").select2({ 
        width: '100%' ,
        theme: "bootstrap-5",
    });
     
    // Validate form on select
    $('form select').on('select2:select', function (e) {
        $(this).valid();
    });

    // Validate form
    $("form.validate-form").each(function (index, form) {
        $(form).validate();
    });

    // Global duplicate submission prevention
    $(document).on('submit', 'form', function (e) {
        if (e.isDefaultPrevented()) {
            return;
        }
        var $form = $(this);
        if ($form.hasClass('no-disable-submit')) {
            return;
        }
        if ($form.data('is-submitting')) {
            e.preventDefault();
            return false;
        }
        $form.data('is-submitting', true);
        var $btn = $form.find('button[type="submit"], input[type="submit"]');
        setTimeout(function () {
            $btn.prop('disabled', true).addClass('disabled');
        }, 0);
    });

    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            $('form').each(function () {
                $(this).removeData('is-submitting');
                $(this).find('button[type="submit"], input[type="submit"]').prop('disabled', false).removeClass('disabled');
            });
        }
    });

    // Add timezone
    $('input[name="timezone"]').val(moment.tz.guess());

    // Number Spinner
    $("input[type='number']").inputSpinner();

    // Make order rows click able.
    $("body").on("click", ".dataTable .dt-order-item", function () {
        window.location = $(this).data("href");
    });

    function fileDescriptionOptions(name) {
        return '<select name="' + name +'" data-rule-required="true" class="file-options input">' +
            '<option value="">--Select Description--</option>' +
            '<option value="Completed Paper">Completed Paper</option>' +
            '<option value="Revised Paper">Revised Paper</option>' +
            '<option value="Draft Paper">Draft Paper</option>' +
            '<option value="Grammarly Report">Grammarly Report</option>' +
            '<option value="Plagiarism Report">Plagiarism Report</option>' +
            '<option value="AI Paper">AI Report</option>' +
            '</select>';
    }

    $('#solution').MultiFile({
        list: '#multiFileList',
        STRING: {
            remove: '<i class="fa fa-trash"></i>',
        },
        afterFileAppend: function (element, value, master_element) {
            $('[title="File selected: ' + value + '"]').append(fileDescriptionOptions(btoa(value)));
        }
    });

    // Multifile
    $('.multi-file').MultiFile({
        list: '#multiFileList',
        STRING: {
            remove: '<i class="fa fa-trash"></i>'
        }
    });

    let start = moment().subtract(29, 'days');
    let end = moment();

    $('.reportRange').daterangepicker({
        startDate: start,
        endDate: end,
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    });

    $(document).ajaxError(function (event, jqxhr, settings, exception) {
        $('form').each(function () {
            $(this).removeData('is-submitting');
            $(this).find('button[type="submit"], input[type="submit"]').prop('disabled', false).removeClass('disabled');
        });
        if (exception === 'Unauthorized') {
            Swal.fire({
                title: "Session Time Out",
                text: "Your session has timed out, Please log in again.",
                type: "warning",
            }).then(() => {
                window.location.replace('/login');
            });
        } else {
            alert(exception);
        }
    });

    $.fn.dataTable.ext.errMode = 'none';
});
